import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import { getS3FileURL } from "@examspark/common";
import { useQueryGetDocument } from "@examspark/common-app";
import { Button, PDFDocument, VFlex, VSpace } from "@examspark/common-ui";
import { IconDownloadLine } from "@examspark/common-ui/dist/components/icons";

import Breadcrumbs from "../../components/common/Breadcrumbs";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";
import ResourceTools from "../../components/resources/ResourceTools";

const StyledDocument = styled.div`
  max-width: 80rem;
  width: 100%;
  margin: 0 auto;
  height: 800px;
  flex: 1;

  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
`;

const DownloadPrompt = styled(VFlex)`
  padding: 5rem;
  border: solid 1px #ddd;
  text-align: center;
  gap: 2rem;
  border-radius: 0.5rem;

  button {
    font-size: 1.4rem;
  }

  h2 {
    font-weight: normal;
    color: #777;
  }
`;

const DocumentRoute = () => {
  const params = useParams<{
    id: string;
  }>();
  const { data } = useQueryGetDocument({
    id: params.id,
    sk: "resource#v0",
  });

  if (!params.id) return null;
  const isPDF = data?.file?.mimetype === "application/pdf";
  const fileUrl = `https://${data?.file?.bucket}.s3.amazonaws.com/${data?.file?.key}`;

  return (
    <VSpace size="3rem">
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Dashboard()} />
        <PageTitle
          subtitle="Document"
          tools={<ResourceTools resource={data} />}
        >
          {data?.name}
        </PageTitle>
      </PageHead>
      {data?.file && isPDF && (
        <StyledDocument>
          <div style={{ height: "70vh" }}>
            <PDFDocument url={getS3FileURL(data?.file)} />
          </div>
        </StyledDocument>
      )}
      {data !== undefined && !isPDF && (
        <DownloadPrompt>
          <h2>This file cannot be previewed in the browser</h2>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "1rem",
            }}
          >
            <Button
              color="primary"
              size="lg"
              title="Download"
              icon={<IconDownloadLine />}
              onClick={() => {
                window.location.href = fileUrl;
              }}
            >
              Download File
            </Button>
          </div>
        </DownloadPrompt>
      )}
    </VSpace>
  );
};

export default DocumentRoute;
